



















































// Importing components
import BaseButton from '@/ui/BaseButton.vue';
import BaseLoadingAnimation from '@/ui/BaseLoadingAnimation.vue';
import BaseSortIcons from '@/ui/BaseSortIcons.vue';
import BaseStorableList from '@/ui/BaseStorableList.vue';
import BaseStorableItem from '@/ui/BaseStorableItem.vue';
// Importing functions
import {deleteCategory} from '@/ts/categories/delete-category';
import {putCategoryOrder} from '@/ts/categories/put-category';

export default {
    name: 'TheTableCategories',
    components: {
        BaseButton,
        BaseLoadingAnimation,
        BaseSortIcons,
        BaseStorableList,
        BaseStorableItem,
    },
    props: {},
    data() {
        return {};
    },
    methods: {
        fire(category_id) {
            this.$swal.fire({
                title: 'Внимание!',
                text: 'Това действие е необратимо, желаете ли да продължите?',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                cancelButtonText: 'Отказ',
                confirmButtonText: 'Изтриване',
            }).then((result) => {
                if (result.value) {
                    deleteCategory(this.$route.params.id, category_id).then(() => {
                        this.$swal.fire(
                            'Изтриването успешно!',
                            '',
                            'success',
                        );
                        const index = this.$store.state.response.response.findIndex((item) => item.id === category_id);
                        this.$store.state.response.response.splice(index, index);
                    });
                }
            });
        },
        updateList(data) {
            putCategoryOrder(data, this.$route.params.id);
        },
    },
};
